import React, { useEffect, useState } from 'react';
import HealthDataBaseTable from './HealthDataBaseTable';
import useTable from '../../Hooks/useTable';
import { HealthDataFilterFormValues } from '../Filter/HealthDataFilterForm';
import { ITableColumn } from '../../../../Models/Table/ITableColumn';
import QuestionnaireResultTableItem from '../../../../Components/Questionnaire/QuestionnaireResultTableItem';
import { Table } from '../../Enums/Table.enum';
import { HealthDataTableColumn, TABLE_COLUMNS } from '../../Utils/tableColumns';
import { IHealthData } from '../../Hooks/useHealthData';
import useTranslation from '../../../../Hooks/useTranslation';

interface HealthDataTable {
	healthData: IHealthData[];
	isLoading: boolean;
	filter: HealthDataFilterFormValues;
	tableName: Table;
}

const HealthDataTable: React.FC<HealthDataTable> = props => {
	const { healthData, isLoading, filter, tableName } = props;
	const [data, setData] = useState<any[]>([]);
	const { getTableData } = useTable();
	const { t } = useTranslation();

	const defaultColumns: ITableColumn[] = [
		{
			key: 'date',
			title: t('base.shared.date'),
			renderItem: (item: { date: string }) => {
				return (
					<QuestionnaireResultTableItem
						value={item.date}
						color={'#ffffff'}
						textColor={'#000000'}
					/>
				);
			},
		},
		{
			key: 'time',
			title: t('base.shared.time'),
			renderItem: (item: { time: HealthDataTableColumn }) => {
				return (
					<QuestionnaireResultTableItem
						value={item.time.value}
						color={item.time.color}
						textColor={item.time.textColor}
					/>
				);
			},
		},
	];

	const columns = [...defaultColumns, ...TABLE_COLUMNS[tableName].columns];

	useEffect(() => {
		if (healthData) {
			const data: any[] = getTableData(
				healthData,
				tableName,
				filter.view,
				filter.type,
			);
			setData(data);
		}
	}, [healthData]);

	return (
		<HealthDataBaseTable
			title={TABLE_COLUMNS[tableName].title}
			rows={data}
			columns={columns}
			isLoading={isLoading}
		/>
	);
};

export default HealthDataTable;
